module.exports = __webpack_public_path__ + "img/client-5.cb2b1e76.png";